module.exports = __webpack_public_path__ + "site/img/wahtsapp_cn.3bd05301.jpg";